/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_ViewInputs */

const en_fw_pub_view = /** @type {(inputs: Fw_Pub_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View template`)
};

const id_fw_pub_view = /** @type {(inputs: Fw_Pub_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat template`)
};

/**
* | output |
* | --- |
* | "View template" |
*
* @param {Fw_Pub_ViewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_view = /** @type {((inputs?: Fw_Pub_ViewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_ViewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_view(inputs)
	return en_fw_pub_view(inputs)
});